// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"c8482690","239":"2f768d6b","420":"b2b2f408","732":"e159fe3d","977":"51a1344e"}[chunkId] + ".chunk.js";
};